import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

type ButtonProps = {
  isSelected: boolean;
};

export const Button = styled.button<ButtonProps>`
  border-radius: 12px;
  border: solid 1px ${({ isSelected }) => (isSelected ? ColorPalette.HEX.BrightOrange : ColorPalette.HEX.LavenderGray)};
  background-color: ${ColorPalette.Transparent};
  padding: 16px 8px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.CharlestonGreen};

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 20px;
    line-height: 1.4;
    letter-spacing: -0.1px;
  }
`;

export const Detail = styled.span`
  font-size: 14px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};
  max-width: 75%;

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 14px;
    line-height: 1.43;
    color: ${ColorPalette.HEX.DimGray};
  }
`;
